import dynamic from "next/dynamic";

export const ReviewsCarousels = dynamic(() => import("./component"));
